module.exports = __webpack_public_path__ + "media/images/mobile/solutions/17-6290f2298b013def257bac2fa9ee2fa1.png";